import React from 'react';
import './style.scss';

const Header1 = ({ title, ...props }) => (<h1 {...props}>{title}</h1>);
const Header2 = ({ title, ...props }) => (<h2 {...props}>{title}</h2>);
const Header3 = ({ title, ...props }) => (<h3 {...props}>{title}</h3>);
const Header4 = ({ title, ...props }) => (<h4 {...props}>{title}</h4>);
const Header5 = ({ title, ...props }) => (<h5 {...props}>{title}</h5>);
const Header6 = ({ title, ...props }) => (<h6 {...props}>{title}</h6>);

const headerMapper = {
  h1: Header1,
  h2: Header2,
  h3: Header3,
  h4: Header4,
  h5: Header5,
  h6: Header6,
};

const HeaderText = ({ title, size = 'h1' }) => {
  const Header = headerMapper[size];
  return (
    <Header title={title} className="custom-header-text" />
  );
}

export default HeaderText;
